import { ApiFunc, getInstance, getNotAuthInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const authorizedInstance = getInstance()
const unauthorizedInstance = getNotAuthInstance()

export const userInfo: ApiFunc<'/user/me/info', 'get'> = data => authorizedInstance.get(API.USER_INFO, { params: data })

export const userActionLog: ApiFunc<'/user/action/log', 'post'> = data =>
  authorizedInstance.post(API.USER_ACTION_LOG, data)

export const signIn: ApiFunc<'/signin', 'post'> = data => unauthorizedInstance.post(API.SIGN_IN, data)

export const sendSms: ApiFunc<'/sms/send', 'post'> = data => unauthorizedInstance.post(API.SMS_SEND, data)

export const sendEmail: ApiFunc<'/email/send', 'post'> = data => unauthorizedInstance.post(API.EMAIL_SEND, data)

export const signUp: ApiFunc<'/signup', 'post'> = data => unauthorizedInstance.post(API.SIGN_UP, data)

export const userUpdatePassword: ApiFunc<'/user/own/password', 'put'> = data =>
  authorizedInstance.put(API.USER_UPDATE_OWN_PASSWORD, data)

export const resetPasswordRequest: ApiFunc<'/action_verification_email/reset/password/request', 'post'> = data =>
  authorizedInstance.post(API.RESET_PASSWORD_REQUEST, data)

export const resetPassword: ApiFunc<'/action_verification_email/reset/password', 'post'> = data =>
  authorizedInstance.post(API.RESET_PASSWORD, data)

export const verifyEmailWithToken: ApiFunc<'/verify-email', 'post'> = data =>
  unauthorizedInstance.post(API.VERIFY_EMAIl, data)

export const verifyEmailWithCode: ApiFunc<'/verify-email', 'post'> = data =>
  authorizedInstance.post(API.VERIFY_EMAIl, data)

export const verifyEmail: ApiFunc<'/verify-email', 'post'> = data => authorizedInstance.post(API.VERIFY_EMAIl, data)

export const saveUserSettings: ApiFunc<'/user/settings/', 'post'> = data =>
  authorizedInstance.post(API.USER_SETTINGS, data)

// CONFERENCE
export const userConferenceInfo: ApiFunc<'/user/conference/me/info', 'get'> = data =>
  authorizedInstance.get(API.USER_CONFERENCE_INFO, { params: data })

export const conferenceSignIn: ApiFunc<'/conference/signin', 'post'> = data =>
  unauthorizedInstance.post(API.CONFERENCE_SIGN_IN, data)

export const conferenceSignUp: ApiFunc<'/conference/signup', 'post'> = data =>
  unauthorizedInstance.post(API.CONFERENCE_SIGN_UP, data)

export const conferenceAuthorProfile: ApiFunc<'/conference/author/profile', 'get'> = data =>
  authorizedInstance.get(API.CONFERENCE_AUTHOR_PROFILE, { params: data })

export const conferenceAuthorProfileSubmit: ApiFunc<'/conference/author/profile', 'post'> = data =>
  authorizedInstance.post(API.CONFERENCE_AUTHOR_PROFILE, data)
